import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  fetchSubjectData,
  fetchEnrollCourses,
  fetchUnitData,
  getEnrolledDocRef,
  saveCourseData
} from '../../Firebase/Course-fb';
import {
  calculateDiscountPercentage,
  calculateTimeUntilEndOfYear,
  filterData,
  sortData
} from '../../Helper/Calculation';
import {
  isLoggedIn,
  getUserDocId,
  getCurrentUserDetail
} from '../../Localstorage';
import { getDoc, updateDoc } from 'firebase/firestore';
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';
import Datanotfound from '../../Helper/Datanotfound';
import logo from '../../Images/Logo/bbarna.png';
import Skeleton from 'react-loading-skeleton';

const Allcourses = () => {
  // const location = useLocation();
  // const course_code = location.state;
  const { subId } = useParams()
  const navigate = useNavigate();
  const { accessCard, accessCallReg, setToast } = useAccessCard();

  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [enroll, setEnroll] = useState([]);
  const [data, setData] = useState({
    mockTests: [],
    fullCourses: [],
    partCourses: []
  });

  // Fetch courses
  useEffect(() => {
    const fetchTopicData = async () => {
      try {
        const subject = await fetchSubjectData(subId);
        const filteredAndSorted = (label) =>
          sortData(filterData(subject, label));

        setData({
          mockTests: filteredAndSorted("Mock Test"),
          fullCourses: filteredAndSorted("Full Course"),
          partCourses: filteredAndSorted("Part Course")
        });
      } catch (err) {
        console.error("Failed to fetch topic data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTopicData();
  }, [subId]);

  // Fetch enrolled data and check screen size
  useEffect(() => {
    const fetchData = async () => {
      if (isLoggedIn()) {
        try {
          const userId = getUserDocId();
          const enrolData = await fetchEnrollCourses(userId);
          setEnroll(enrolData[0].course_list || []);
        } catch (error) {
          console.error("Error fetching enrolled courses:", error);
        }
      }
    };

    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', checkMobile);

    checkMobile();
    fetchData();

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const showToast = (msg, type) => {
    setToast({ message: msg, type });
  };

  const handleToTopic = async (subject_code, foundItem) => {
    navigate(`/topic/${subject_code}`)
    // navigate('/topic', { state: subject_code })
    // const filteredEnrollUnit = enroll.find(
    //   (item) => item.subject_code === subject_code
    // )?.unit_code_list;

    // const topic = await fetchUnitData(subject_code);
    // const topic_filter = sortData(topic.filter((t) => t.willShow === true));

    // navigate('/topic', { state: { topic_filter, filteredEnrollUnit } });
  };

  const handlePayment = async (event, item) => {
    event.preventDefault();

    if (!isLoggedIn()) {
      accessCard();
      accessCallReg();
      return;
    }

    const getUserId = getUserDocId();
    const user = getCurrentUserDetail()[0];

    const enrolData = {
      access_till: calculateTimeUntilEndOfYear(),
      access_type: "PAID",
      subject_code: item.subject_code,
      subject_image: item.subject_image,
      subject_name: item.subject_name,
      unit_code_list: []
    };

    const course = {
      course_list: [enrolData],
      student_id: getUserId,
      student_name: user.name
    };

    const res = await fetch(
      "https://us-central1-bbarna-6a725.cloudfunctions.net/createRazorpayOrder",
      {
        method:"POST",
        headers: {"Content-Type":"application/json"},
        body: JSON.stringify({amount:(item.selling_price || item.subject_price)})
      }
    );

    const data = await res.json();

    const options = {
      key: "rzp_live_ALbX7RKvJAGMtR",
      amount: (item.selling_price || item.subject_price) * 100,
      currency: "INR",
      name: "B_BARNA",
      description: "Course Payment",
      order_id: data.id,
      image: logo,
      handler: async () => {
        try {
          const docRef = await getEnrolledDocRef(getUserId);

          if (docRef) {
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
              const existingData = docSnap.data();
              const updatedCourseList = [...existingData.course_list, enrolData];

              await updateDoc(docRef, {
                course_list: updatedCourseList,
              });
            } else {
              console.log("No enrolled document found for this user!");
            }
          } else {
            await saveCourseData(course);
          }

          showToast('🎉 Payment Successful!', 'success');
          navigate("/");
        } catch (error) {
          showToast('Error storing course info...', 'error');
          console.error("Error storing course info:", error);
        }
      },
      prefill: {
        name: user.name,
        contact: user.mobile_number,
      },
      theme: {
        color: "#09636e",
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();

    rzp.on('payment.failed', (response) => {
      console.error("Payment failed:", response.error);
      showToast(`❌ Payment Failed: ${response.error.description || 'Try again later.'}`, 'error');
    });
  };

  // Show loader
  if (loading) {
    return (
      <div className='course_container'>
        <div className="loader">
          Loading topics...
          <div className="spinner" />
          {/* Replace with a spinner component if you prefer */}
        </div>
      </div>
    );
  }

  // Show DataNotFound if all course categories are empty
  const isEmpty =
    data.mockTests.length === 0 &&
    data.fullCourses.length === 0 &&
    data.partCourses.length === 0;

  if (isEmpty) {
    return <Datanotfound />;
  }

  const renderCourses = (courses, title) => (
    <div className='course_container'>
      {courses.length > 0 && (
        <>
          <h2>{title}</h2>
          <div className='course_inner_container'>
            {courses.map((item, index) => {
              const foundItem = enroll.find(
                (enrollItem) => enrollItem.subject_code === item.subject_code
              );

              return (
                <div key={index} className="course_card_sub">
                  <div onClick={() => handleToTopic(item.subject_code, foundItem)}>
                    {item.selling_price && (
                      <div className="course_price">
                        {calculateDiscountPercentage(item.subject_price, item.selling_price)}% OFF
                      </div>
                    )}
                    {item.subject_image && (
                      <img
                        className="course_card_img"
                        src={item.subject_image}
                        alt={item.subject_name || "Course Image"}
                      />
                    )}
                    <div className={`heading sub ${item.subject_name.length > (isMobile ? 17 : 20) ? "long-text" : ""}`}>
                      <span>{item.subject_name}</span>
                    </div>
                  </div>
                  <div className="course_btn sub">
                    {foundItem ? (
                      <div className="enrolled">Enrolled</div>
                    ) : (
                      <div
                        className="pay"
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePayment(e, item);
                        }}
                      >
                        Buy Now ({item.selling_price || item.subject_price}/-)
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );

  return (
    <>
      {renderCourses(data.fullCourses, "Full Courses")}
      {renderCourses(data.mockTests, "Mock Tests")}
      {renderCourses(data.partCourses, "Part Courses")}
    </>
  );
};

export default Allcourses;
